import { render, staticRenderFns } from "./page4.vue?vue&type=template&id=03d08a7d&scoped=true&"
import script from "./page4.vue?vue&type=script&lang=ts&"
export * from "./page4.vue?vue&type=script&lang=ts&"
import style0 from "./page4.vue?vue&type=style&index=0&id=03d08a7d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d08a7d",
  null
  
)

export default component.exports